import { useContext, useEffect, useState } from "react";
import ReportHeader from "../../components/ReportHeader";
import useAxios from "../../common/hook/useAxios";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/AuthContext";
import { formatDate } from "../../constant";
import { FaFilePdf } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";

const ToxPage = () => {
  const [searchParams] = useSearchParams()
  const patientId = searchParams.get("patientId") ?? "";
  const patientName = searchParams.get("patientName") ?? "";
  const { request } = useAxios();
  const { user } = useContext(AuthContext);
  const [toxTableData, setToxTableData] = useState([]);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [searchTox, setSearchTox] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDos, setSearchDos] = useState("");
  useEffect(() => {
    if (user) {
      getToxReportData();
    }
  }, [user]);

  const getToxReportData = async () => {
    const formattedFromDate = await formatDate(fromDate);
    const formattedToDate = await formatDate(toDate);
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabResults/TOXDetails?sInputJSON={'objLab':{'PatientID':${patientId ? patientId : "0"},'PracticeID':${user?.PracticeID},'ResultType':0,'FromDOS':'${formattedFromDate}','ToDOS':'${formattedToDate}','LocID':0,'TimeZoneOffSet':${user?.DefaultTimeZoneOffSet} }}`;
    request(url, {
      headers: {
        Authorization: `Bearer ${user?.AuthToken}`,
      },
      method: "GET",
    })
      .then((res) => {
        setToxTableData(res);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error occurred while fetching labs", {
          autoClose: 3000,
        });
      });
  };

  const filteredPatients =
    toxTableData?.length > 0 &&
    toxTableData?.filter((row) => {
      const fullName = `${row.FirstName} ${row.LastName}`?.toLowerCase();
      const searchTermNormalized = searchTerm?.trim()?.toLowerCase();
      const dosTypeMatches = row.DOS.trim()
        .toLowerCase()
        .includes(searchDos?.toLowerCase().trim());
      return fullName.includes(searchTermNormalized) && dosTypeMatches;
    });

  return (
    <div>
      <ReportHeader
        title1="Scan And Upload Tox Report"
        title2="Search Tox Report"
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        searchTox={searchTox}
        setSearchTox={setSearchTox}
        getReportData={getToxReportData}
        uploadUrl="ToxResults"
        refreshData={getToxReportData}
        id={patientId}
        name={patientName}
      />
      <div className="overflow-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-blue-400 border-b border-black text-white">
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                #
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Location
              </th>
              {!patientId &&
                <th
                  style={{ whiteSpace: "nowrap" }}
                  className="p-2 border-r border-black flex flex-col"
                >
                  Patient Name
                  <input
                    type="text"
                    className="text-gray-800 text-sm mt-1"
                    placeholder="Search by Patient Name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ marginBottom: "10px", padding: "5px" }}
                  />
                </th>
              }
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                DOS <br></br>
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1"
                  placeholder="Search Date"
                  value={searchDos}
                  onChange={(e) => setSearchDos(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Request
              </th>
              {/* <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Request Date
              </th> */}

              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Req / Control #
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Screening
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                Confirmation
              </th>
            </tr>
          </thead>{" "}
          <tbody>
            {toxTableData && Array.isArray(toxTableData) ? (
              ((searchTerm || searchDos) !== ""
                ? filteredPatients
                : toxTableData
              ).map((row, index) => (
                <tr key={row.id} data-tooltip-place="top">
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {index + 1}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row.location}
                  </td>
                  {!patientId &&
                    <td
                      style={{ whiteSpace: "nowrap" }}
                      className="p-2 border-r border-b border-black cursor-pointer text-blue-700 underline"
                      onClick={() => {
                        const url = `/patient-dashboard?patientId=${row?.PatientID}&patientName=${encodeURIComponent(row?.FirstName + row?.LastName)}`;
                        window.open(url, "_blank");
                      }}
                    >
                      {`${row?.LastName || ""}, ${row?.FirstName || ""}`}
                    </td>
                  }
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row?.DOS}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row?.ResultWebPath && (
                      <a
                        href={row.ResultWebPath}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cursor-pointer"
                      >
                        <FaFilePdf className="text-red-400" />
                      </a>
                    )}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row?.RequisitionNumber}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row?.PScreeningResults}
                  </td>
                  <td
                    style={{ whiteSpace: "nowrap" }}
                    className="p-2 border-r border-b border-black"
                  >
                    {row?.CNFResults}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} className="p-2 text-center">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ToxPage;
